import {dispatch} from '@wordpress/data';
import {useEffect} from '@wordpress/element';



/**
 * [shetradesBlockView description]
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */
export function shetradesBlockView(props) {

	/**
	 * [_dispatchYearTo description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	function _dispatchYearTo(e) {
		const storyYearTo = e.target.value;
		jQuery('#form_stories_field_year_to').val(storyYearTo);
	} 

	let years = [];
    

	if (props.years) {
		years = Object.entries(props.years).map(([id, value]) => {					                		
				var year_current = jQuery('#form_stories_field_year_to').val(); 
				if (value == year_current) { 
					return <option value={value} selected="selected">{value}</option>
				}
				return <option value={value}>{value}</option>
			}
		)
	}
 
	return (				
		<div className="form-field">
            <select onChange={(e) => _dispatchYearTo(e)}>
            	<option value="0">All</option>
                {years}
            </select>
		</div>
	);

}